import { useParams } from "react-router-dom";
import { useState } from "react";

const UpgradePage = () => {
  const { token } = useParams();
  const [loading, setLoading] = useState(false);

  const handleUpgrade = async () => {
    setLoading(true);

    try {
      const res = await fetch(
        "https://event.greatnigerian.org/api/event/upgrade-checkout/",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token }),
        }
      );

      const data = await res.json();

      if (data.url) {
        window.location.href = data.url;
      } else {
        alert(data.error || "Something went wrong");
      }
    } catch (err) {
      alert("Network error");
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-lg w-full bg-white p-8 rounded-xl shadow-md text-center">
        <h2 className="text-2xl font-bold mb-4">
          Upgrade to Premium 🚀
        </h2>

        <p className="text-gray-600 mb-6">
          Unlock full access to premium sessions, certification,
          and exclusive AI business tools.
        </p>

        <div className="mb-6 text-left text-sm text-gray-700">
          <ul className="space-y-2">
            <li>✔ Certificate of Participation</li>
            <li>✔ Access to AI Business Community</li>
            <li>✔ Exclusive Post-Summit Session</li>
            <li>✔ Premium Templates & Automation</li>
          </ul>
        </div>

        <button
          onClick={handleUpgrade}
          disabled={loading}
          className="w-full bg-green-700 text-white py-3 rounded-lg font-semibold hover:bg-green-800 transition"
        >
          {loading ? "Processing..." : "Pay $120 & Upgrade"}
        </button>
      </div>
    </div>
  );
};

export default UpgradePage;